// src/Utils/urineMapping.js
// Maps Routine Panel urine tests to their machine codes + ParameterIDs.

import { URINE_COLOR_PARAMETER_ID } from "./urineColors";

export const urineMapping = {
  "urine glucose": {
    code: "GLU",
    ParameterID: "KIU1513",
  },
  "urine blood": {
    code: "BLD",
    ParameterID: "KIU5853",
  },
  "urine protein": {
    code: "PRO",
    ParameterID: "KIU5691",
  },
  "urine ketones": {
    code: "KET",
    ParameterID: "KIU4330",
  },
  "urine urobilinogen": {
    code: "UBG",
    ParameterID: "KIU0121",
  },
  "urine nitrite": {
    code: "NIT",
    ParameterID: "KIU5213",
  },
  "urine leukocyte": {
    code: "LEU",
    ParameterID: "KIU8382",
  },
  "urine specific gravity": {
    code: "SG",
    ParameterID: "KIU4022",
  },
  "urine ph": {
    code: "pH",
    ParameterID: "KIU5349",
  },
  "urine bilirubin": {
    code: "BIL",
    ParameterID: "KIU6268",
  },
};

// Convenience helpers for quick lookups inside hooks/components.
// Urine Color is part of the panel on screen, but it has no strip code, so it
// is kept out of the sets that drive the machine fetch.
export const URINE_PANEL_PARAMETER_IDS = Object.values(urineMapping).map(
  ({ ParameterID }) => ParameterID
);

export const URINE_PANEL_PARAMETER_SET = new Set(URINE_PANEL_PARAMETER_IDS);

export const URINE_PANEL_PARAM_TO_CODE = Object.values(urineMapping).reduce(
  (acc, { code, ParameterID }) => {
    if (ParameterID) acc[ParameterID] = (code || "").toUpperCase();
    return acc;
  },
  {}
);

export const URINE_PANEL_CODE_TO_PARAM = Object.values(urineMapping).reduce(
  (acc, { code, ParameterID }) => {
    if (code) acc[(code || "").toUpperCase()] = ParameterID;
    return acc;
  },
  {}
);

// Every ParameterID shown under the "Routine Panel" heading, strip codes plus
// the manually picked Urine Color.
export const ROUTINE_PANEL_PARAMETER_SET = new Set([
  ...URINE_PANEL_PARAMETER_IDS,
  URINE_COLOR_PARAMETER_ID,
]);
